import React, { createContext, useContext } from 'react';
import useDataSync from '../../routes/Setup/Database/DataSync/useDataSync';

type DataSyncContextType = ReturnType<typeof useDataSync>;

const DataSyncContext = createContext<DataSyncContextType | null>(null);

export function DataSyncProvider({ children }: { children: React.ReactNode }) {
    const value = useDataSync();
    return <DataSyncContext.Provider value={value}>{children}</DataSyncContext.Provider>;
}

export function useDataSyncContext(): DataSyncContextType {
    const ctx = useContext(DataSyncContext);
    if (!ctx) throw new Error('useDataSyncContext must be used within DataSyncProvider');
    return ctx;
}

export default DataSyncContext;
